import { get } from 'lodash';

export function injectUpgradeInterceptor(requests = [], redirectUrl = '/upgrade') {
    requests.forEach((request) => {
        if (typeof get(request, 'interceptors.response.use') !== 'function') {
            return;
        }

        request.interceptors.response.use(
            (res) => res,
            (err) => {
                const status = get(err, 'response.status');
                const code = get(err, 'response.data.code');
                // web个人版需要对接口响应http状态码400，业务错误码10010427 做全局的处理，“升级中，不可用”的错误码进行全局处理跳到"升级维护页"
                if (status === 400 && String(code) === '10010427') {
                    document.location.href = redirectUrl;
                }
            },
        );
    });
}
